module.exports = __webpack_public_path__ + "static/img/throttleProBg-1.a4f588c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/throttleProBg-1.png
// module id = u2hM
// module chunks = 1